import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCreditsExhaustedStore = create(
	persist(
		(set, get) => ({
			dismissedAt: {},

			shouldShowModal: (userId, throttleMs) => {
				const timestamp = get().dismissedAt[userId];
				if (!timestamp) return true;
				return Date.now() - timestamp >= throttleMs;
			},

			dismiss: (userId) =>
				set((state) => ({
					dismissedAt: { ...state.dismissedAt, [userId]: Date.now() },
				})),
		}),
		{ name: 'b2bhero:credits-exhausted' },
	),
);
